import React, { useEffect, useState } from "react";
import { Table } from "antd";
import getLocationsColumns from "../../../const/Columns/getLocationsColumns";
import {
  deleteLocationsServer,
  getLocationsServer,
} from "../../../apis/locationsApi";
import { Link } from "react-router-dom";

const Locations = () => {
  const [locations, setLocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchText, setSearchText] = useState("");
  const [filteredlocs, setFilteredLocs] = useState([]);

  useEffect(() => {
    fetchLocations();
  }, []);

  useEffect(() => {
    if (locations?.length > 0) {
      const filtered = locations?.filter((loc) =>
        loc.name?.toLowerCase().includes(searchText.toLowerCase()),
      );
      setFilteredLocs(filtered);
    }
  }, [searchText, locations]);

  const fetchLocations = async () => {
    try {
      const res = await getLocationsServer();
      setLocations(res.result);
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const deleteLocations = async (id) => {
    const isConfirmed = window.confirm(
      "Are you sure you want to delete this Location?",
    );
    if (isConfirmed) {
      await deleteLocationsServer(id);
      setLoading(true);
      fetchLocations();
    }
  };

  const columns = getLocationsColumns(deleteLocations);
  return (
    <>
      <div className="main-wrapper">
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="d-flex  justify-content-between  align-items-center">
              <Link to="/AddLocations" className="btn add-new btn-primary mb-3">
                Add Locations
              </Link>
              {/* Search Input */}
              <input
                type="text"
                placeholder="Search by title"
                className="form-control w-25"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
            {loading ? (
              <div>Loading...</div>
            ) : (
              <div className="table-respoinsive">
                <Table
                  columns={columns}
                  dataSource={
                    searchText && filteredlocs?.length > 0
                      ? filteredlocs
                      : locations?.length > 0
                        ? locations
                        : []
                  }
                  className="table-striped "
                  rowKey={(record) => record.id}
                  // scroll={{ y: 400 }}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Locations;
